@if (visible()) {
  <div class="fa-backdrop" (click)="dismiss()"></div>
  <div class="fa-modal">
    <button class="fam-close" (click)="dismiss()" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>

    @if (currentFeature(); as feature) {
      <div class="fa-card">
        @if (feature.badge_text) {
          <span class="fa-badge">{{ feature.badge_text }}</span>
        }

        <div class="fa-icon-wrap">
          <i class="pi pi-{{ feature.icon || 'star' }}"></i>
        </div>

        <h2 class="fa-title">{{ feature.title }}</h2>
        <p class="fa-description">{{ feature.description }}</p>
      </div>
    }

    <!-- Progress dots -->
    @if (!isSingle()) {
      <div class="fa-dots">
        @for (f of features(); track f.id; let i = $index) {
          <span class="fa-dot" [class.active]="i === activeIndex()" (click)="activeIndex.set(i)"></span>
        }
      </div>
    }

    <!-- Actions -->
    <div class="fa-actions">
      @if (isLast() || isSingle()) {
        <button class="fa-btn-primary" (click)="dismiss()">Got it</button>
      } @else {
        <button class="fa-btn-primary" (click)="next()">Next</button>
      }
    </div>

    <button class="fa-suppress" (click)="suppress()">Don't show for 7 days</button>
  </div>
}
